import type { Routes } from '@angular/router';

export const STATISTICS_PDF_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('#shell/layouts/logged-in-layout/restaurants/statistics-pdf-layout/statistics-pdf-layout.component').then(
                (m) => m.StatisticsPdfLayoutComponent
            ),
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'seo',
            },
            {
                path: 'seo',
                loadChildren: () => import('#modules/statistics-seo/routes/seo-statistics.routes').then((m) => m.SEO_STATISTICS_PDF_ROUTES),
            },
            {
                path: 'seo/keywords',
                loadChildren: () => import('#modules/statistics-seo/routes/seo-statistics.routes').then((m) => m.SEO_STATISTICS_PDF_ROUTES),
            },
            {
                path: 'seo/impressions',
                loadChildren: () => import('#modules/statistics-seo/routes/seo-statistics.routes').then((m) => m.SEO_STATISTICS_PDF_ROUTES),
            },
            {
                path: 'e-reputation',
                loadChildren: () =>
                    import('#modules/statistics-e-reputation/routes/e-reputation-statistics.routes').then(
                        (m) => m.E_REPUTATION_STATISTICS_PDF_ROUTES
                    ),
            },
            {
                path: 'social-networks',
                loadChildren: () =>
                    import('#modules/statistics-social-networks/routes/social-networks.routes').then(
                        (m) => m.SOCIAL_NETWORKS_STATISTICS_PDF_ROUTES
                    ),
            },
            {
                path: 'boosters',
                loadChildren: () =>
                    import('#modules/statistics-boosters/routes/boosters-statistics.routes').then((m) => m.BOOSTERS_STATISTICS_PDF_ROUTES),
            },
        ],
    },
];
